<template>
  <div id="manageEditApp">
    <md-card>
      <md-card-header class="md-secondary">
      <!-- :data-background-color="dataBackgroundColor" -->
        <h4 class="md-title fw-bold">Edit Profile</h4>
        <p class="md-body-1 m-1">Complete your profile</p>
      </md-card-header>

      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>User Name</label>
              <md-input v-model="edit.username" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Email Address</label>
              <md-input v-model="edit.emailadress" type="email"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>First Name</label>
              <md-input v-model="edit.firstname" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Last Name</label>
              <md-input v-model="edit.lastname" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field maxlength="5">
              <label>About Me</label>
              <md-textarea v-model="edit.aboutme"></md-textarea>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100 text-right">
            <md-button class="md-raised md-success">Update Profile</md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
export default {
  name: 'ManageEditApp',
  data () {
    return {
      edit: {
        username: null,
        disabled: null,
        emailadress: null,
        lastname: null,
        firstname: null,
        address: null,
        city: null,
        country: null,
        code: null,
        aboutme:
          "Lamborghini Mercy, Your chick she so thirsty, I'm in that two seat Lambo."
      }
    }
  }
}
</script>
